import { getDexConfig } from '@/utils/get-dex-config.js';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import PropTypes from 'prop-types';

const OnBoardingLeftComponent = () => {

	const { dex } = getEnvAndDex();
	const { backgroundImage,LandingLogo,  tagline, HeroCircle } = getDexConfig(dex);

	const loginBackgroundStyles = {
		backgroundImage: `url("../img/${backgroundImage}")`
	}

	return (
		<div className="layout-login__left" style={loginBackgroundStyles} data-testid="layout-left">
			<div className='layout-login__logo'>
				{LandingLogo && <LandingLogo />} <span className="layout-login__logo__text">Admin</span>
			</div>
			<div className='layout-login__description'>
				<div className='layout-login__title'>
					{tagline}
				</div>
			</div>

			{HeroCircle ? <div className="layout-login__image-overlay"><HeroCircle /></div> : <img className='layout-login__image-overlay' src="../img/Shape.png" alt='fallback shape' />}
		</div>
	)
}

OnBoardingLeftComponent.propTypes = {
	dex: PropTypes.string
}

export default OnBoardingLeftComponent;
